import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';

import { wacToken } from '@/libraries/design/foundations';
import { RichTextComponent } from '@/libraries/design/utils';

import { ErrorIcon } from './error-icon';
import { ProTipIcon } from './pro-tip-icon';

export type PanelType = 'pro-tip' | 'highlight';

export interface PanelProps {
	panelType: PanelType;
	label: string;
	description: string | React.ReactElement<typeof RichTextComponent>;
}

export const Panel = (props: PanelProps) => {
	const isProTip = props.panelType === 'pro-tip';
	const descriptionComponent =
		typeof props.description === 'string' ? <p>{props.description}</p> : props.description;

	const panelContainerCss = css({
		borderRadius: wacToken('corner.radius.card'),
		backgroundColor: wacToken('color.neutral.light200'),
		padding: `${token('space.300')} ${token('space.400')}`,
		display: 'flex',
		gap: isProTip ? token('space.300') : token('space.400'),

		[media.below.sm]: {
			flexDirection: 'column',
			gap: token('space.100'),
		},

		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		['p']: {
			margin: 0,
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		['p.eyebrow-lg']: {
			marginBlockEnd: token('space.100'),
			marginBlockStart: isProTip ? token('space.100') : '10px',
		},
	});

	return (
		<div css={panelContainerCss}>
			<div>{isProTip ? <ProTipIcon /> : <ErrorIcon />}</div>
			<div>
				<p className="eyebrow-lg">{props.label}</p>
				{descriptionComponent}
			</div>
		</div>
	);
};
